import { RouterProvider } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { ApiProvider } from '~/api/ApiProvider';
import { detectApi } from '~/api/detect';
import type { WorkspaceApi } from '~/api/WorkspaceApi';
import { ToastProvider } from '~/ui/Toast';
import { createAppRouter } from './router';

/** Finds the api (real or mock), then mounts the app. */
export function AppRoot({ api: given }: { api?: WorkspaceApi }) {
  const [api, setApi] = useState<WorkspaceApi | null>(given ?? null);
  const [router] = useState(() => createAppRouter());
  useEffect(() => {
    if (api) return;
    let live = true;
    void detectApi().then((a) => {
      if (live) setApi(a);
    });
    return () => {
      live = false;
    };
  }, [api]);
  if (!api) {
    return (
      <div
        role="status"
        aria-label="Opening Workspace"
        className="flex min-h-screen items-center justify-center bg-paper"
      >
        <span className="font-display text-22 font-semibold text-ink">Workspace</span>
      </div>
    );
  }
  return (
    <ApiProvider api={api}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </ApiProvider>
  );
}
